module.exports = __webpack_public_path__ + "img/wh_05.3cb74857.png";